<template>
  <v-container class="v-sheet-main-container screens elevation-12">
    <v-toolbar flat class="v-toolbar-custom">
      <v-btn depressed fab dark small class="custom-header-btn font-italic font-weight-medium mr-1" to="Screens"><v-icon> mdi-arrow-left </v-icon> <!--{{  $t('global.back')  }}--></v-btn>
      <v-toolbar-title class="ma-2" v-if="screen">{{ $t('screens.playlist') }} : {{screen.server_name}}</v-toolbar-title>
<!--         <v-select dark
          style="max-width:250px!important"
          class="px-3 pt-5"
          :items="screenList"
          v-model="chosenScreen"
          item-text="name"
        ></v-select> -->
      <v-spacer></v-spacer>
      <v-menu 
        bottom
        left
        transition="slide-x-reverse-transition"
        origin="top right"
      >
        <template v-slot:activator="{ on: menu }">
          <v-tooltip color="rgba(0,0,0,0.2)" left>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn depressed fab small dark v-on="{...tooltip, ...menu}" class="custom-header-btn">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span> Aide contextuelle </span>
          </v-tooltip>
        </template>
        <v-card dark color="menuTooltip" class="helpMenu">
          <v-card-text class="body-1 font-weight-regular text-center pb-0" style="color:white!important">
            Vous souhaitez organiser votre playlist ?
          </v-card-text>
          <v-card-text class="body-2 text-center" >
            Très simplement, ordonnez vos medias à l'aide des flèches situées au début de chaque ligne.<br><v-icon class="mt-2" large dark>mdi-chevron-up</v-icon><v-icon class="mt-2" large dark>mdi-chevron-down</v-icon>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="body-2 d-flex flex-row mx-auto text-left">
            <v-icon large class="mr-3">mdi-television-play</v-icon>L'ordre de lecture de vos médias s'executera du haut vers le bas.
          </v-card-text>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-sheet id="my-content-wrapper" class="border-main-content elevation-3 scrollPlaylist" style="height:calc(100% - 152px)!important">
      <div class="custom-center justify-start my-3" style="display:flex;">
        <v-tooltip open-delay="600" max-width="250" color="screens" bottom style="border-radius:8em!important;">
          <template v-slot:activator="{ on }">
            <v-text-field v-on="on"
              color="screens"
              style="max-width:300px!important;"
              class="px-3"
              placeholder="Rechercher"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              :clearable="true"
              clear-icon="mdi-close-circle"
              rounded
              filled
              dense
              :hide-details="true"
            ></v-text-field>
          </template>
          <span> Pour rechercher un média saisissez son nom ou un mot clé. </span>
        </v-tooltip>
        <v-tooltip open-delay="600" max-width="250" color="screens" bottom style="border-radius:8em!important;">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-select
                :menu-props="{contentClass: 'customSelect'}"
                color="screens"
                item-color="screens"
                append-icon="mdi-chevron-down"
                style="max-width:270px!important;"
                class="px-3 custom"
                :items="contentStatus"
                v-model="chosenStatus"
                @change="changeFilter"
                return-object
                item-text="name"
                item-value="id"
                :hide-details="true"
                rounded
                filled
                dense
              ></v-select>
            </div>
          </template>
          <span>Affiche les médias avec le statut sélectionné.</span>
        </v-tooltip>
        <v-btn v-if="keyRerender > 0" rounded large depressed color="new_media" style="color:white!important;" @click="saveOrder"> Valider l'ordre </v-btn>
      </div>
       <transition-group name="flip-list" tag="div" class="screen-content" style="height: calc(100vh + -242px); overflow-x: hidden; overflow-y: auto; padding-left :12px;">
        <template  v-for="content in allFiles">
          <component :is="screenManageContentComponent" v-bind:key="content.id" v-bind:content='content' v-bind:screen="screen" >
            <template v-slot:position>
              {{content.playlistOrder}}
            </template>
          </component>
        </template>
       </transition-group>
     </v-sheet>
     <v-dialog v-model="dialogConfirmRemove" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
       <v-card class="pa-4">
        <v-card-text class="mt-3 title font-italic" style="color:var(--v-primary-base)!important">
         {{ $t('userMessage.media-delete-title') }}
        </v-card-text>
        <v-tooltip open-delay="800ms" bottom color="rgba(var(--editScreens-rgb),1)">
          <template v-slot:activator="{ on }">
            <img class="mb-2" style="height:274px;width:274px;" src="@/assets/images/illu_delete_playlist.png" v-on="on">
          </template>
          <span>Illustration : Ivan Haidutski</span>
        </v-tooltip>
        <v-card-text class="body-2" style="color:var(--v-primary-base);">
          {{ $t('userMessage.media-delete-message') }}
        </v-card-text>
        <v-card-text class="font-weight-medium" style="color:var(--v-primary-base);"><v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
          {{ $t('userMessage.media-delete-warning') }}
        </v-card-text>
        <v-card-actions>
          <v-btn large rounded depressed text style="width:45%" @click="dialogConfirmRemove = false">{{ $t('global.cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn large outlined rounded style="width:45%" class="custom-valid-btn playlist" @click="removeImage">{{ $t('global.confirm') }}</v-btn>
        </v-card-actions>
       </v-card>
     </v-dialog>
    <modals-container @close="showSnackbars"/>
    <v-snackbar @click.native="snackbarRemoveSuccessful = true" v-model="snackbarRemoveSuccessful" :timeout="timeoutDuration">
      {{ $t('userMessage.media-delete-success') }}
    </v-snackbar>
     <v-snackbar @click.native="snackbarRemoveFailed = false" v-model="snackbarRemoveFailed" :timeout="timeoutDuration">
      {{ $t('userMessage.media-delete-failed') }}
    </v-snackbar>
    <v-snackbar @click.native="snackbarEditSuccessful = false" v-model="snackbarEditSuccessful" :timeout="timeoutDuration">
      Le média a bien été modifié
    </v-snackbar>
  </v-container>
</template>

<script>
import FtpService from '@/services/FTPService'
import ContentSettingEditModal from './Subcomponents/ContentSettingsEditModal'
import ScreenManageContentComponent from './Subcomponents/ScreenManageContentComponent'
import SuspendMediaModal from './Subcomponents/SuspendMediaModal'
import CreationModal from './Subcomponents/CreationModal'
import StartMediaBroadcastModal from './Subcomponents/StartBroadcastModal'

export default {
  data () {
    return {
      screen: null,
      videoFilesArray: [],
      imageFilesArray: [],
      screentype: '',
      height: 146,
      snackbarRemoveSuccessful: false,
      snackbarRemoveFailed: false,
      timeoutDuration: 4000,
      loading: true,
      dialogConfirmRemove: false,
      fileToRemove: null,
      search: '',
      videoFilesToDisplay: [],
      imageFilesToDisplay: [],
      snackbarEditSuccessful: false,
      contentStatus: [
        {id: 0, name: this.$i18n.t('contentStatus.all')},
        {id: 1, name: this.$i18n.t('contentStatus.ongoing')},
        {id: 2, name: this.$i18n.t('contentStatus.upcoming')},
        {id: 3, name: this.$i18n.t('contentStatus.ongoing-and-upcoming')},
        {id: 4, name: this.$i18n.t('contentStatus.suspended')},
        {id: 5, name: this.$i18n.t('contentStatus.over')}
      ],
      chosenStatus: { id: 3, name: this.$i18n.t('contentStatus.ongoing-and-upcoming') },
      duplicateCheck: [],
      allFiles: [],
      keyRerender: 0,
      existingPlaylistOrder: null,
      screenManageContentComponent: ScreenManageContentComponent
    }
  },
  components: {
    ContentSettingEditModal,
    ScreenManageContentComponent,
    SuspendMediaModal,
    CreationModal,
    StartMediaBroadcastModal
  },
  async mounted () {
    this.$store.dispatch('setFile', null)
    this.screen = this.$store.state.selectedScreen
    if (this.screen === null) {
      this.$router.replace({
        name: 'Screens'
      })
    } else {
      if (this.screen.fk_screen_type === 1 || this.screen.fk_screen_type === 3) {
        this.screentype = ''
      } else if (this.screen.fk_screen_type === 2 || this.screen.fk_screen_type === 4) {
        this.screentype = 'portrait'
      }
      const serverPath = 'https://sandisplay.allsan.fr/players/' + this.$store.state.selectedSite.SitNom + '/PUB/' + this.screen.server_name + '/bloc_pub1/'
      const previewPath = 'https://sandisplay.allsan.fr/players/' + this.$store.state.selectedSite.SitNom + '/PUB/' + this.screen.server_name + '/'
    
      this.fetchContent()
    }
  /*   var binary = ''
    var bytes = new Uint8Array(response.data.file.data)
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    this.file = 'data:image/png;base64,' + btoa(binary) */
  },
  methods: {
    showSnackbars () {
      if (this.$store.state.editSuccessful === true){
        this.snackbarEditSuccessful = true
        this.$store.dispatch('setEditSuccessful', false)
        this.fetchContent()
      }
    },
    async saveOrder () {
      var playlistOrder = []
      this.allFiles.forEach((element) => {
        if (element.playlistOrder) {
          playlistOrder.push(element)
        }
      })

      playlistOrder.sort(function(a, b){
        if (a.playlistOrder > b.playlistOrder) { return 1}
        if (a.playlistOrder < b.playlistOrder) { return -1}
        return 0
      })
      var playlistName = []
      playlistOrder.forEach(element => {
        if (element.media_name) {
          if (element.media_name.endsWith('.avi')) {
            playlistName.push(element.media_name + '.mp4')
          } else {
            playlistName.push(element.media_name)
          }
        } else {
           if (element.id.endsWith('.avi')) {
            playlistName.push(element.id + '.mp4')
          } else {
            playlistName.push(element.id)
          }
        }
      })

      const saveOrderResponse = await FtpService.savePlaylistOrder({
        site: this.$store.state.selectedSite.SitNom,
        screen: this.screen,
        playlistOrder: playlistName
      })
      this.keyRerender = 0
    },
    changeOrder (file, up) {
      this.allFiles.forEach((element, index, array) => {
        if (element === file) {
          if (up) {
            element.playlistOrder -= 1
            array[index-1].playlistOrder +=1
          } else {
            element.playlistOrder += 1
            array[index+1].playlistOrder -=1
          }
        }
      })
      this.allFiles.sort(function(a, b){
        if (a.playlistOrder > b.playlistOrder) { return 1}
        if (a.playlistOrder < b.playlistOrder) { return -1}
        return 0
      })
      this.keyRerender = 1
    },
    async fetchContent () {
      var response = await FtpService.fetchContent({
        site: this.$store.state.selectedSite.SitNom,
        screen: [this.screen]
      })

      const response2 = await FtpService.fetchOldContent({
        site: this.$store.state.selectedSite.SitNom,
        screen: [this.screen]
      })

      const responsePlaylist = await FtpService.fetchPlaylistOrder({
        site: this.$store.state.selectedSite.SitNom,
        screen: this.screen
      })

      this.existingPlaylistOrder = responsePlaylist.data.order

      var newMediaName = []
      var oldMedia = []
      response.data.files.forEach(media => {
        newMediaName.push(media.media_name)
      })

     response2.data.medias.forEach(media => {
        var nameNoAvi = media.name.split('.')[0] + '.' + media.name.split('.')[1]      
        if (!newMediaName.includes(nameNoAvi)) {
          oldMedia.push(media)
        }
      })
      const groupBy = key => array =>
      array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key]
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
        return objectsByKeyValue
      }, {})

      const groupByName = groupBy('name')
      var oldMediaByName = groupByName(oldMedia)
      oldMediaByName = Object.values(oldMediaByName)


      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month.toString()
      }
      var day = date.getDate()
      if (day < 10) {
        day = '0' + day.toString()
      }
      var today = year.toString() + month.toString() + day.toString()
      //  trier video et image
      response.data.files.forEach(element => {
        var d = element.date_debut.substring(0,4).toString() + element.date_debut.substring(5,7).toString() + element.date_debut.substring(8).toString()
        var f = element.date_fin ? element.date_fin.substring(0,4).toString() + element.date_fin.substring(5,7).toString() + element.date_fin.substring(8).toString() : null
        element.suspendable = false
        element.isOldFile = false
        if (parseInt(d, 10) > parseInt(today, 10)) {
          element.statusClass = 'programmed'
          element.status = this.screentype === 'portrait' ? '' : 'Programmé'
          element.suspendable = true
          element.statusIcon = 'mdi-calendar-check-outline'
        } else if (!element.suspendu){
          element.statusClass = 'suspended'
          element.status = this.screentype === 'portrait' ? '' : 'Suspendu'
          element.suspendable = true
          element.statusIcon = 'mdi-television-pause'
        } else if (parseInt(f, 10) >= parseInt(today, 10)) {
          element.statusClass = 'ongoing'
          element.status = this.screentype === 'portrait' ? '' : 'En diffusion'
          element.statusIcon = 'mdi-television-play'
        } else if (parseInt(f, 10) < parseInt(today, 10)) {
          element.statusClass = 'done'
          element.status = this.screentype === 'portrait' ? '' : 'Terminé'
          element.statusIcon = 'mdi-calendar-remove-outline'
        } else {
          element.statusClass = 'ongoing'
          element.status = this.screentype === 'portrait' ? '' : 'En diffusion'
          element.statusIcon = 'mdi-television-play'
        }     
        if (element.media_name.endsWith('.mp4')) {
          if (!this.duplicateCheck.includes(element.id)) {
            this.duplicateCheck.push(element.id)
            this.videoFilesArray.push(element)
          } /* else {
            for (let i = 0; i < this.videoFilesArray.length; i++) {
              if (this.videoFilesArray[i].id === element.id) {
                this.videoFilesArray[i] = element
                break
              }
            }
          } */
        } else if (!element.media_name.endsWith('.properties')) {
          if (!this.duplicateCheck.includes(element.id)) {
            this.duplicateCheck.push(element.id)
            this.imageFilesArray.push(element)
          }/*  else {
            for (let i = 0; i < this.imageFilesArray.length; i++) {
              if (this.imageFilesArray[i].media_name === element.media_name) {
                continue
              } else {
                this.imageFilesArray.splice(i, 1, null)         
                this.imageFilesArray.push(element)     
                break
              }
            }
          } */
        }
      })
      oldMediaByName.forEach(element => {
        var name = element[0].name
        element.id = element[0].name
        element.isOldFile = true
        element.fileProps = element
        var d = name.includes('__d') ? name.split('__d')[1].substring(0,8) : null
        var f = name.includes('__f') ? name.split('__f')[1].substring(0,8) : null
        element.suspendable = false
        if (parseInt(d, 10) > parseInt(today, 10)) {
          element.statusClass = 'programmed'
          element.status = this.screentype === 'portrait' ? '' : 'Programmé'
          element.suspendable = true
          element.statusIcon = 'mdi-calendar-check-outline'
        } else if (parseInt(f, 10) >= parseInt(today, 10)) {
          element.statusClass = 'ongoing'
          element.status = this.screentype === 'portrait' ? '' : 'En diffusion'
          element.statusIcon = 'mdi-television-play'
        } else if (parseInt(f, 10) < parseInt(today, 10)) {
          element.statusClass = 'done'
          element.status = this.screentype === 'portrait' ? '' : 'Terminé'
          element.statusIcon = 'mdi-calendar-remove-outline'
        } else {
          element.statusClass = 'ongoing'
          element.status = this.screentype === 'portrait' ? '' : 'En diffusion'
          element.statusIcon = 'mdi-television-play'
        }
        if (element.id.endsWith('.mp4')) {
          if (!this.duplicateCheck.includes(element.id)) {
            this.duplicateCheck.push(element.id)
            this.videoFilesArray.push(element)
          }
        } else if (!element.id.endsWith('.properties')) {
          if (!this.duplicateCheck.includes(element.id)) {
            this.duplicateCheck.push(element.id)
            this.imageFilesArray.push(element)
          }
        }
      })
      this.changeFilter()
    },
    editSettings (fileToEdit) {
      this.$modal.show(ContentSettingEditModal, {file: fileToEdit, from: 'screen'}, {clickToClose: false, transition: 'scale-transition', adaptive: true, maxWidth: 560, height: '80%'})
    },
    async removeImage () {
      if (this.fileToRemove.isOldFile) {
        var paths = []
        for (let i = 0; i < this.fileToRemove.length; i++) {
          paths.push(this.fileToRemove[i].path)
        }
        const response = await FtpService.removeOldFile({
          paths: paths
        })
        if (response) {
          if (response.status === 200) {
            this.dialogConfirmRemove = false
            this.snackbarRemoveSuccessful = true
          } else {
            this.snackbarRemoveFailed = true
          }
        }
        let fileToRemove = this.fileToRemove
        if (this.fileToRemove.id.endsWith('.mp4')) {
          this.videoFilesArray = this.videoFilesArray.filter(function (element) {
            return element.id !== fileToRemove.id
          })
        } else {
          this.imageFilesArray = this.imageFilesArray.filter(function (element) {
            return element.id !== fileToRemove.id
          })
        }
        this.search = null
      } else {
        const response = await FtpService.removeImage({
          filename: this.fileToRemove.media_name,
          id: this.fileToRemove.id,
          site: this.$store.state.selectedSite.SitNom,
          user: this.$store.state.user.id
        })
        if (response) {
          if (response.status === 200) {
            this.dialogConfirmRemove = false
            this.snackbarRemoveSuccessful = true
          } else {
            this.snackbarRemoveFailed = true
          }
        }
        let fileToRemove = this.fileToRemove
        if (fileToRemove.media_name.endsWith('.mp4')) {
          this.videoFilesArray = this.videoFilesArray.filter(function (element) {
            return element.media_name !== fileToRemove.media_name
          })
        } else {
          this.imageFilesArray = this.imageFilesArray.filter(function (element) {
            return element.media_name !== fileToRemove.media_name
          })
        }
        this.search = null
      }
    },
    confirmRemove (file) {
      this.fileToRemove = file
      this.dialogConfirmRemove = true
    },
    showSuspendMediaModal (fileToSuspend) {
      this.$modal.show(SuspendMediaModal, {file: fileToSuspend}, {clickToClose: false, adaptive: true, transition: 'scale-transition', maxWidth: 558, height: 'auto'})
    },
    editMedia () {
      this.$modal.show(CreationModal, {}, {clickToClose: false, adaptive: true, width: '80%', height: '90%'})
    },
    startMediaBroadcast (fileToBroadcast) {
      this.$modal.show(StartMediaBroadcastModal, {file: fileToBroadcast}, {clickToClose: false, adaptive: true, transition: 'scale-transition', maxWidth: 558, height: 'auto'})
    },
    changeFilter () {
      this.imageFilesToDisplay = []
      if (this.chosenStatus.id === 0) {
        this.imageFilesToDisplay = this.imageFilesArray.filter(function (element) {
          return element.statusClass === 'ongoing' ||  element.statusClass === 'programmed' || element.statusClass === 'suspended'
        }) 
        this.videoFilesToDisplay = this.videoFilesArray.filter(function (element) {
          return element.statusClass === 'ongoing' ||  element.statusClass === 'programmed' || element.statusClass === 'suspended'
        }) 
      } else if (this.chosenStatus.id === 1) {
        this.imageFilesToDisplay = this.imageFilesArray.filter(function (element) {
          return element.statusClass === 'ongoing'
        }) 
        this.videoFilesToDisplay = this.videoFilesArray.filter(function (element) {
          return element.statusClass === 'ongoing'
        }) 
      } else if (this.chosenStatus.id === 2) {
        this.imageFilesToDisplay = this.imageFilesArray.filter(function (element) {
          return element.statusClass === 'programmed'
        }) 
        this.videoFilesToDisplay = this.videoFilesArray.filter(function (element) {
          return element.statusClass === 'programmed'
        }) 
      } else if (this.chosenStatus.id === 3) {
        this.imageFilesToDisplay = this.imageFilesArray.filter(function (element) {
          return element.statusClass === 'ongoing' || element.statusClass === 'programmed'
        }) 
        this.videoFilesToDisplay = this.videoFilesArray.filter(function (element) {
          return element.statusClass === 'ongoing' || element.statusClass === 'programmed'
        })
      } else if (this.chosenStatus.id === 4) {
        this.imageFilesToDisplay = this.imageFilesArray.filter(function (element) {
          return element.statusClass === 'suspended'
        }) 
        this.videoFilesToDisplay = this.videoFilesArray.filter(function (element) {
          return element.statusClass === 'suspended'
        })
      } else {
        this.imageFilesToDisplay = this.imageFilesArray.filter(function (element) {
          return element.statusClass === 'done'
        }) 
        this.videoFilesToDisplay = this.videoFilesArray.filter(function (element) {
          return element.statusClass === 'done'
        })
      }
      this.allFiles = this.videoFilesToDisplay.concat(this.imageFilesToDisplay)
      if (!this.existingPlaylistOrder) {
        this.allFiles.sort(function(a, b){
          if (Number.isInteger(a.id) && Number.isInteger(b.id)) {
            if (a.media_name < b.media_name) { return 1 }
            if (a.media_name > b.media_name) { return -1 } 
            return 0
          }else if (Number.isInteger(a.id) && b.id !== null) {
            if (a.media_name < b.id) { return 1 }
            if (a.media_name > b.id) { return -1 }
            return 0
          } else if (a.id !== null && Number.isInteger(b.id)) {
            if (a.id < b.media_name) { return 1 }
            if (a.id > b.media_name) { return -1 }
            return 0
          } else {
            if (a.id < b.id) { return 1 }
            if (a.id > b.id) { return -1 }
            return 0
          }      
        })
      }
      if (this.screen.name !== 'Ligne de caisse') {
        this.allFiles.forEach((element, index, array) => {
          if (this.existingPlaylistOrder) {
            var videoMediaName = element.media_name ? element.media_name + '.mp4' : element.id + '.mp4'
            var alreadyOrdered = false
            for (let i = 0; i < this.existingPlaylistOrder.length; i++) {
              if (element.id === this.existingPlaylistOrder[i] || element.media_name === this.existingPlaylistOrder[i] || videoMediaName === this.existingPlaylistOrder[i]) {
                element.playlistOrder = i + 1
                element.playlistLength = array.length
                alreadyOrdered = true
                break
              }
            }
            if (!alreadyOrdered) {
              element.playlistOrder = index + this.existingPlaylistOrder.length
              element.playlistLength = array.length
            }
          } else {
            if (element.statusClass === 'ongoing' || element.statusClass === 'programmed') {
              element.playlistOrder = index + 1
              element.playlistLength = array.length
            }
          }         
        })
        if (this.existingPlaylistOrder) {
          this.allFiles.sort(function(a, b){
            if (a.playlistOrder > b.playlistOrder) { return 1 }
            if (a.playlistOrder < b.playlistOrder) { return -1 } 
          })
        }
      }
    }
  },
  watch: {
    search: function () {
      if (this.search === null || this.search === '') {
        this.videoFilesToDisplay = this.videoFilesArray
        this.imageFilesToDisplay = this.imageFilesArray
      } else {
        this.videoFilesToDisplay = this.videoFilesArray.filter((element) => {
          if (element.titre !== undefined) {
            return element.titre.includes(this.search)
          }
        })
        this.imageFilesToDisplay = this.imageFilesArray.filter((element) => {
          if (element.titre !== undefined) {
            return element.titre.includes(this.search)
          }
        })
      }
    }
  }
}
</script>

<style scoped>

.screen-content{
  overflow: auto;
}

.loading {
  background: rgba(0, 0, 0, 0.12)!important;
}

.loading::after{
  animation: loading 1.5s infinite;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: 1;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
}

</style>
